import { render, staticRenderFns } from "./boutique_vignette.vue?vue&type=template&id=9e604c2a&scoped=true&"
import script from "./boutique_vignette.vue?vue&type=script&lang=js&"
export * from "./boutique_vignette.vue?vue&type=script&lang=js&"
import style0 from "./boutique_vignette.vue?vue&type=style&index=0&id=9e604c2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e604c2a",
  null
  
)

export default component.exports